// extracted by mini-css-extract-plugin
export default {"container":"Stadium24_container__MUIZB","nameCell":"Stadium24_nameCell__whEs3"};